// @todo проверить, нужен ли этот eslint-disable
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useMemo, useState } from "react";
import { Button, Div, Panel, PanelHeader, ScreenSpinner, Text } from "@vkontakte/vkui";
import { connect } from "react-redux";
import stylesSCSS from "./styles.module.scss";
import globalSCSS from "../../styles/styles.module.scss";


import { SelectBox } from "../../components";
import styles from "./DoctorPanel.style";
import { setActivePanel, setPreviousPanel } from "../../redux/actions/panelsActions";
import { restartSteps } from "../../redux/actions/regionAndMedicalOrganisationActions";

import { panels } from "../../variables";
import {
  selectDoctorName,
  selectDoctorSpeciality,
  startDoctorNamesLoading,
  startDoctorsSpecialitiesLoading,
} from "../../redux/actions/doctorsActions";
import { clearDateTime } from "../../redux/actions/datesActions";
import Icon28ArrowLeftOutline from "@vkontakte/icons/dist/28/arrow_left_outline";

const DoctorPanel = ({
  id,
  goBack,
  startDoctorsSpecialitiesLoading,
  goToDatePanel,
  showDoctorsLoader,
  showDoctorNamesLoader,
  medicalOrganisationId,
  sessionId,
  orderId,
  regionCode,
  startDoctorNamesLoading,
  doctorNames,
  selectDoctorName,
  doctorSpecialities,
  selectedDoctorsSpeciality,
  selectedDoctorName,
  selectedMedicalOrganisation,
  selectDoctorSpeciality,
  clearSelectedName,
  doctorsError,
}) => {
  useEffect(() => {
    startDoctorsSpecialitiesLoading(
      medicalOrganisationId,
      sessionId,
      orderId,
      regionCode
    );
    if (selectedDoctorName) {
      selectDoctorName(null);
    }
  }, []);

  useEffect(() => {
    if (selectedDoctorsSpeciality) {
      selectDoctorSpeciality(null);
      setTimeout(() => {
        startDoctorNamesLoading(
          selectedDoctorsSpeciality.Service_Id,
          sessionId,
          orderId,
          regionCode
        );
      }, 300); // @todo без таймаута почему-то иногда не работает, бэкэнд выдает ошибку, что услуга не найдена
    }
  }, []);

  const getDoctorName = (doctorName) => {
    return doctorName.Resource_Name;
  };

  const mapSpecialityOption = (doctorSpeciality) => {
    return {
      id: doctorSpeciality.Service_Id,
      value: ucFirst(doctorSpeciality.Service_Name),
    };
  };

  const ucFirst = (str) => {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1);
  };

  const mapNameDoctorOption = (doctorName) => {
    return {
      id: getDoctorName(doctorName),
      value: getDoctorName(doctorName),
    };
  };
  const doctorSpecialitieItems = useMemo(
    () => doctorSpecialities?.map(mapSpecialityOption) ?? [],
    [doctorSpecialities]
  );
  const doctorNamesItems = useMemo(
    () => doctorNames?.map(mapNameDoctorOption) ?? [],
    [doctorNames.length]
  );

  return (
    <Panel id={id}>
      <PanelHeader
        left={
          <Div
            style={{
              margin: "0",
              padding: "0",
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <Icon28ArrowLeftOutline
              style={{
                paddingLeft: "6px",
              }}
              onClick={() => goBack()}
              fill={"#06844D"}
            />
            <Text
              style={{
                ...styles.headerText,
              }}
            >
              Запись к врачу
            </Text>
          </Div>
        }
        separator={false}
      ></PanelHeader>
      {showDoctorsLoader ? (
        <ScreenSpinner className={stylesSCSS['spinner']} />
      ) : (
        <>
          {selectedMedicalOrganisation && (
            <Div style={styles.blockMO}>
              <Text style={styles.blockMOName}>
                {selectedMedicalOrganisation.Organization_Name}
              </Text>
              <Text style={styles.blockMODesc}>
                {selectedMedicalOrganisation.Address_MO}
              </Text>
            </Div>
          )}

          <Div style={styles.selectLabel}>Специальность врача</Div>
          <SelectBox
            disabled={showDoctorsLoader}
            selected={selectedDoctorsSpeciality?.Service_Name}
            style={styles.inputSelector}
            items={doctorSpecialitieItems}
            placeholder="Выберите специальность"
            onChange={(event) => {
              let spec = null;
              let specKey = event.id;
              if (doctorSpecialities.length) {
                doctorSpecialities.forEach((item, key) => {
                  if (item.Service_Id === specKey) {
                    spec = item;
                  }
                });
              }
              if (spec) {
                startDoctorNamesLoading(
                  spec.Service_Id,
                  sessionId,
                  orderId,
                  regionCode
                );
                selectDoctorSpeciality(spec);
                clearSelectedName();
              }
            }}
          />
          <>
            {doctorsError ? (
              <Text style={styles.doctorsErrorMessage}>{doctorsError}</Text>
            ) : (
              <>
                <Text style={styles.errorMessage}>
                  Если вы не нашли врача нужной вам специальности, то запись к
                  нему возможна только по направлению.{" "}
                </Text>
                <Div style={styles.selectLabel}>Специалист</Div>
                <SelectBox
                  style={styles.inputSelector}
                  items={doctorNamesItems}
                  selected={selectedDoctorName?.Resource_Name}
                  disabled={!selectedDoctorsSpeciality || showDoctorNamesLoader}
                  placeholder="Выберите специалиста"
                  onChange={(event) => {
                    let docname = null;
                    let docnameKey = event.id;
                    if (doctorNames.length) {
                      doctorNames.forEach((item, key) => {
                        if (getDoctorName(item) === docnameKey) {
                          docname = item;
                        }
                      });
                    }
                    if (docname) {
                      selectDoctorName(docname);
                    }
                  }}
                />
                 <Button disabled={!selectedDoctorName} onClick={goToDatePanel} className={globalSCSS['button']}>Выбрать дату и время</Button>
                {showDoctorNamesLoader && (
                  <ScreenSpinner className={stylesSCSS['spinner__selector']} />
                )}
              </>
            )}
          </>
        </>
      )}
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    medicalOrganisationId:
      state.regionAndMedicalOrganisation.selectedMedicalOrganisation &&
      state.regionAndMedicalOrganisation.selectedMedicalOrganisation.MO_Id,
    sessionId: state.userInfo.userInfo.sessionId,
    orderId: state.regionAndMedicalOrganisation.orderId,
    regionCode: state.regionAndMedicalOrganisation.selectedRegion.regionCode,
    showDoctorsLoader: state.loader.showDoctorsLoader,
    showDoctorNamesLoader: state.loader.showDoctorNamesLoader,
    selectedDoctorsSpeciality: state.doctors.selectedDoctorSpeciality,
    doctorSpecialities: state.doctors.doctorsSpecialities,
    selectedDoctorName: state.doctors.selectedDoctorName,
    selectedMedicalOrganisation:
      state.regionAndMedicalOrganisation.selectedMedicalOrganisation,
    doctorNames: state.doctors.doctorNames,
    doctorsError: state.doctors.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => {
      dispatch(setPreviousPanel());
      dispatch(selectDoctorSpeciality(null));
      dispatch(selectDoctorName(null));
      dispatch(restartSteps());
    },
    selectDoctorSpeciality: (doctorSpeciality) =>
      dispatch(selectDoctorSpeciality(doctorSpeciality)),
    clearSelectedName: () => dispatch(selectDoctorName(null)),
    startDoctorsSpecialitiesLoading: (...args) => {
      dispatch(startDoctorsSpecialitiesLoading(...args));
    },
    goToDoctorSpecialitySelector: () =>
      dispatch(setActivePanel(panels.doctorSpecialitySelector)),
    goToDoctorNameSelector: () => {
      dispatch(setActivePanel(panels.doctorNameSelector));
      dispatch(clearDateTime());
    },
    goToDatePanel: () => {
      dispatch(clearDateTime());
      dispatch(setActivePanel(panels.choseDate));
    },
    startDoctorNamesLoading: (...args) =>
      dispatch(startDoctorNamesLoading(...args)),
    selectDoctorName: (doctorName) => dispatch(selectDoctorName(doctorName)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DoctorPanel);
